import React, { useEffect, useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import MultiInputDataTag from "./MultiInputDataTag";

const NestedInputMultiple = ({ item }) => {
  const {
    label,
    name,
    type,
    multiple,
    multipleData,
    required,
    noImage,
    textAreaRequired,
    index,
  } = item;

  const [removeHelper, setRemoveHelper] = useState(null);
  const [idCount, setIdCount] = useState(1);
  useEffect(() => {
    if (multipleData?.length > 1) {
      setIdCount(multipleData.length);
    }
  }, [multipleData]);

  const [quantityCount, setCount] = useState(
    multipleData
      ? multipleData?.map((item, idx) => (
          <MultiInputDataTag
            // key={index}
            label={label}
            id={idx + 1}
            name={name}
            type={type}
            required={required}
            textAreaRequired={textAreaRequired}
            noImage={noImage}
            setRemoveHelper={setRemoveHelper}
            multipleData={multipleData}
            defaultTitle={item?.defaultValue?.title || ""}
            defaultParagraph={item?.defaultValue?.paragraph || ""}
            defaultImage={item?.defaultValue?.image || ""}
            indexNo={item?.defaultValue?.index || ""}
            imgTitle={item?.defaultValue?.imgTitle || ""}
          />
        ))
      : [
          <MultiInputDataTag
            //id={idCount}
            key={label}
            label={label}
            name={name}
            type={type}
            required={required}
            textAreaRequired={textAreaRequired}
            noImage={noImage}
            setRemoveHelper={setRemoveHelper}
            indexNo={index}
            multipleData={multipleData}
            defaultImage={item?.defaultValue?.image || ""}
            defaultTitle={item?.defaultValue?.title || ""}
            defaultParagraph={item?.defaultValue?.paragraph || ""}
            imgTitle={item?.defaultValue?.imgTitle || ""}
          />,
        ]
  );

  useEffect(() => {
    if (removeHelper) {
      const temp = quantityCount.filter(
        (item) => item?.props?.id !== removeHelper
      );
      setCount(temp);
    }
  }, [removeHelper]);

  const handleAddElement = () => {
    setIdCount(idCount + 1);
    setCount((current) => [
      ...current,
      <MultiInputDataTag
        id={idCount + 1}
        label={label}
        name={name}
        type={type}
        required={required}
        textAreaRequired={textAreaRequired}
        noImage={noImage}
        setRemoveHelper={setRemoveHelper}
        indexNo={index}
        multipleData={multipleData}
        defaultTitle=""
        defaultParagraph=""
        imgTitle=""
        defaultImage=""
      />,
    ]);
  };

  return (
    <>
      <div className="col-span-3 flex flex-col gap-4 items-centers w-full fitHeight">
        {/* <label className="label">
          <span className="text-base font-semibold">{label}</span>
        </label> */}
        <div className=" w-full ">
          {quantityCount?.map((item, index) => item)}
        </div>

        {multiple && (
          <div
            className={`${
              quantityCount.length > 0 ? "-mt-16" : ""
            } flex justify-start w-full items-end`}
          >
            <div
              onClick={handleAddElement}
              className="flex gap-2 border rounded-full border-gray-800 py-1 px-4 pr-1"
            >
              <label className="label cursor-pointer">
                <span className="text-base font-semibold">Add {label}</span>
              </label>
              <button
                type="button"
                className="btn btn-circle"
                title={`Add ${label}` || ""}
              >
                <BsPlusLg />
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default NestedInputMultiple;
